// extracted by mini-css-extract-plugin
export default {"button":"ModeButton_button__zccCq"};